/**
 * @file SitePreviewDialog.tsx
 * @description Предпросмотр сайта на весь экран (phase19.16 Р1;
 * uiux-design-r1 §1 «360 — Предпросмотр (на весь экран)», §6 «Посмотреть»).
 *
 * На телефоне и планшете — главный способ увидеть черновик: «←
 * Предпросмотр», экран и ширина, внизу «[К настройкам] [Опубликовать]».
 * Для версии из истории (`source`) — без переключателя «Черновик | Сейчас»
 * и без публикации. Экран и ширина — общие с предпросмотром панелей.
 */

import { ArrowLeft } from "lucide-react";

import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogTitle } from "../../ui/dialog";
import { canOpenPublish, useSiteView } from "../site-view-context";
import { SitePreviewFrame } from "./SitePreviewFrame";
import type { SitePreviewSource } from "../../../lib/site-view/types";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  /** Версия из истории; нет — черновик. */
  source?: SitePreviewSource;
}

export function SitePreviewDialog({ open, onClose, title = "Предпросмотр", source }: Props) {
  const view = useSiteView();
  const draftMode = !source;

  return (
    <Dialog open={open} onOpenChange={(next) => (!next ? onClose() : null)}>
      <DialogContent
        showClose={false}
        className="left-0 top-0 flex h-dvh w-full max-w-none translate-x-0 translate-y-0 flex-col gap-3 rounded-none p-3 sm:p-4"
      >
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="Закрыть предпросмотр">
            <ArrowLeft className="size-5" />
          </Button>
          <DialogTitle>{title}</DialogTitle>
        </div>
        {open ? (
          <SitePreviewFrame source={source} fill />
        ) : null}
        <div className="grid shrink-0 grid-cols-2 gap-2 pb-[env(safe-area-inset-bottom)] sm:flex sm:justify-end">
          <Button variant="outline" onClick={onClose}>
            {draftMode ? "К настройкам" : "Закрыть"}
          </Button>
          {draftMode ? (
            <Button
              variant="brand"
              disabled={!canOpenPublish(view.changes)}
              onClick={() => view.openDialog("publish")}
            >
              Опубликовать
            </Button>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
}
